<template>
  <b-container fluid>
    <backlink />
    <h1>Réclamations &amp; déclarations</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider">
      <template slot="status" slot-scope="{ data }">
        <b-badge variant="primary">{{ data.value }}</b-badge>
      </template>
    </AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";

export default {
  name: "ComplaintList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
    };
  },
  computed: {
    options: function () {
      return {
        complaint_type_slug_options: this.$store.getters["complaint/getTypes"],
        request_kind_options: this.$store.getters["complaint/getRequestKinds"],
        from_mcs_options: [
          { value: null, text: "Toutes" },
          { value: '1', text: "Import MCS" },
          { value: '0', text: "Catalogue ESM" },
        ],
        status_options: this.$store.getters["status/getByGroup"]("complaint").selectOptions(
          "status_slug",
          "name"
        ),
      };
    },
  },
  methods: {
    /**
     * Fourni les données à AdminTableSync. Cette méthode est appelée à chaque 
     * rafraichissement de la liste
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {object}        {
                                  total: Nombre total de résultats,
                                  items: Items à afficher
                                }
     */
    itemsProvider(ctx) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "complaint", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              statusSlug: ctx.extended_filters_model.status,
              typeSlug: ctx.extended_filters_model.complaint_type_slug,
              startCreatedAd: ctx.extended_filters_model.created_at.start
                ? self.$moment(ctx.extended_filters_model.created_at.start).format("YYYY-MM-DD")
                : null,
              endCreatedAd: ctx.extended_filters_model.created_at.end
                ? self.$moment(ctx.extended_filters_model.created_at.end).format("YYYY-MM-DD")
                : null,
              from_mcs: ctx.extended_filters_model.from_mcs,
              requestKind: ctx.extended_filters_model.request_kind,
            },
          })
          .then((response) => {
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.complaints || [],
            });
          })
          .catch((error) => {
            self.$toastr.error("Le chargement de la liste a échoué");
            self.inGenerating = false;
          });
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Complaint/ComplaintList.vue